import { ComponentsProps, ComponentsOverrides, ComponentsVariants, Theme } from '@mui/material';

export const MuiSvgIcon: {
    defaultProps?: ComponentsProps['MuiSvgIcon'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiSvgIcon'];
    variants?: ComponentsVariants['MuiSvgIcon'];
} = {
    variants: [
        {
            props: { fontSize: 'small' },
            style: { fontSize: '1.25rem' },
        },
        {
            props: { fontSize: 'medium' },
            style: { fontSize: '1.5rem' },
        },
    ],
};
